var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"series-container"},[_c('ModuleTitle',{attrs:{"caption":_vm.service.caption,"text":_vm.service.desc}}),_c('List',{attrs:{"items":_vm.service.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }